module.exports = __webpack_public_path__ + "static/media/map_legendary.18bb3f74.png";